export async function renderShapeAnimation({
	container,
	shape,
	shapes,
	count,
	cellTemplate,
	getShapeFrames,
	shuffleArray,
	inlineCells,
}) {
	if (!cellTemplate) {
		console.error('Cell template not found');
		return;
	}

	try {
		const shapeSequence = Array.isArray(shapes) && shapes.length > 0
			? shapes
			: (shape ? Array.from({ length: count }, () => shape) : []);

		if (shapeSequence.length === 0) {
			return;
		}

		const uniqueShapes = [...new Set(shapeSequence)];
		const framesByShape = new Map();

		await Promise.all(
			uniqueShapes.map(async (shapeKey) => {
				const cachedFrames = await getShapeFrames(shapeKey);
				framesByShape.set(shapeKey, cachedFrames);
			})
		);

		container.innerHTML = '';
		const localCells = [];
		const targetCount = Math.max(0, count || shapeSequence.length);

		for (let i = 0; i < targetCount; i += 1) {
			const shapeKey = shapeSequence[i % shapeSequence.length];
			const shapeFrames = framesByShape.get(shapeKey) || [];
			if (shapeFrames.length === 0) {
				continue;
			}

			const node = cellTemplate.content.firstElementChild.cloneNode(true);
			node.classList.remove('artist-cell');
			node.classList.add('shape-cell');
			const pathEl = node.querySelector('path');
			const labelEl = node.querySelector('.artist-cell-label');
			if (labelEl) {
				labelEl.remove();
			}

			const frames = shuffleArray(shapeFrames);
			pathEl.setAttribute('d', frames[0] || '');
			container.appendChild(node);
			localCells.push({ pathEl, frames, frameIndex: 0 });
		}

		inlineCells.push(...localCells);
	} catch (error) {
		console.error('Failed to load shape animation:', error);
	}
}

export async function initShapeAnimations({
	renderShapeAnimationImpl,
}) {
	const shapeElements = document.querySelectorAll('[data-shape-animation-shape], [data-shape-animation-shapes]');
	for (const element of shapeElements) {
		const shape = element.getAttribute('data-shape-animation-shape');
		const rawShapes = element.getAttribute('data-shape-animation-shapes');
		const count = parseInt(element.getAttribute('data-shape-animation-count') || '20', 10);

		let shapes = [];
		if (rawShapes) {
			try {
				const parsed = JSON.parse(rawShapes);
				if (Array.isArray(parsed)) {
					shapes = parsed
						.map((item) => String(item || '').trim())
						.filter((item) => item.length > 0);
				}
			} catch (_error) {
				shapes = [];
			}
		}

		if (shape || shapes.length > 0) {
			await renderShapeAnimationImpl(element, shape, count, shapes);
		}
	}
}
